import request from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-cart'

type InvitationRequest = Omit<paths['/api/carts/multi-carts/{multiCartId}/users/invite']['post']['parameters']['body']['payload'], 'brand'>
type InvitationResponse = paths['/api/carts/multi-carts/{multiCartId}/users/invite']['post']['responses']['201']['content']['application/json']

export type MultiCartInvitationUsers = paths['/api/carts/multi-carts/{multiCartId}/users/invite']['post']['parameters']['body']['payload']['users']

export function inviteUsersToMultiCart(cartId: string, users: MultiCartInvitationUsers) {
  const payload = { users }
  return request.post<InvitationResponse, InvitationRequest>(`/api/carts/multi-carts/${cartId}/users/invite`, payload, { credentials: 'include' })
}
